import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

faker.seed(1);

export default Factory.extend({
	id: () => faker.string.uuid(),
	natureTypeOwner: { id: 'F', name: 'FÍSICA' },
	owner: trait({
		description: () => `${faker.person.firstName()} ${faker.person.lastName()}`,
		type: 'owner',
		status: 'active',
	}),
	user: trait({
		description: () => `${faker.person.firstName()} ${faker.person.lastName()}`,
		type: 'user',
		status: 'banned',
	}),
	insurance: trait({
		description: 'SEGUROS',
		type: 'owner',
		status: 'active',
	}),
	J: trait({
		natureTypeOwner: { id: 'J', name: 'JURÍDICA' },
	}),
});
